// extracted by mini-css-extract-plugin
export var addToCartButton = "_lr-b";
export var arrowButtonContainer = "_lr-9";
export var arrowButtonIcon = "_lr-a";
export var carouselArrowButton = "_lr-6";
export var carouselElementContainer = "_lr-1";
export var left = "_lr-7";
export var productDisplayCarouselContainer = "_lr-0";
export var productTileContainer = "_lr-2";
export var productTileImage = "_lr-4";
export var productTileImageContainer = "_lr-3";
export var productTileTitle = "_lr-5";
export var right = "_lr-8";
export var sliderOverflow = "_lr-c";